import useToaster from "./useToaster";

export default function useRecordings() {
  const { addToaster } = useToaster();
  const baseUrl = process.env.REACT_APP_API_URL || "";
  const url = `${baseUrl}/api/recordings`;

  const safeFetch = async (endpoint, options = {}) => {
    try {
      const token = localStorage.getItem("x-token");
      const headers = { "Content-Type": "application/json" };
      headers["Authorization"] = `Bearer ${token}`;

      const response = await fetch(endpoint, { ...options, headers });

      if (response.status === 401) {
        // App's auth-logout handler clears the session and flips to <Login>.
        window.dispatchEvent(new Event("auth-logout"));
        // Early-return: a 401 body is empty, so calling response.json() below
        // throws a cryptic "Unexpected end of JSON input".
        throw new Error("Session expired — please log in again");
      }
      // Parse defensively: a 502/504 from the proxy returns HTML (not JSON), so
      // response.json() would throw and mask the real status. Surface status.
      let data = null;
      try {
        data = await response.json();
      } catch {
        if (!response.ok) throw new Error(`Request failed (${response.status})`);
      }
      if (!response.ok) {
        throw new Error(data?.message || `Request failed (${response.status})`);
      }
      return data;
    } catch (error) {
      addToaster({
        message: `${error?.message || JSON.stringify(error)}`,
        severity: "error",
      });
      throw error;
    }
  };

  const listRecordings = () => safeFetch(url);

  const rerunRecordings = (keys) =>
    safeFetch(`${url}/rerun`, {
      method: "POST",
      body: JSON.stringify({ keys }),
    });

  return { listRecordings, rerunRecordings };
}
